import { Skeleton } from 'antd';
import classNames from 'classnames';
import type { GroupDataProps } from './studyDetailsTab.types';
import './style.scss';

/**
 * Renders one titled block of study detail content. Once the data has loaded the title and content are wrapped in a group container with the supplied class name, otherwise a skeleton placeholder stands in.
 *
 * @param isLoadedData - Whether study data has loaded; defaults to false and shows a skeleton.
 * @param className - Extra class name applied to the group container.
 * @param title - Block heading.
 * @param content - Block body.
 * @returns The group block or its loading skeleton.
 */
const GroupData = ({ isLoadedData = false, className, title, content }: GroupDataProps) =>
  isLoadedData ? (
    <div className={classNames(className, 'group-container')}>
      <div className="title group-block-title">{title}</div>
      <div className="content">{content}</div>
    </div>
  ) : (
    <div className="loading-group">
      <Skeleton />
    </div>
  );

export default GroupData;
